export default __webpack_public_path__ + "static/valore-logo-6629fd7696a9dafa74d92d510fb3f1f6.png";